export const pageNames: Record<string, string> = {
  dashboard: 'Dashboard',
  articles: 'Articles',
  brands: 'Brand Management',
  advertorials: 'Advertorial Management',
  subscription: 'Subscription',
  profile: 'Profile',
  settings: 'Settings',
  reports: 'Reports',
};
